import { Types, types } from '../types'

export const getNarrators = () => {
  return {
    type: types.GET_NARRATOR,

  }
}

export const getAllMusicOnHoldAction = (id) => {
  return {
    type: types.GET_ALL_MUSIC_ON_HOLD,
    id
  }
}

export const returnToOldId = (id, path, page) => {
  return {
    type: types.PUSH_RETURN_TO_OLD_ID,
    id, path, page
  }
}


export const setLineServiceType = (serviceType) => {
  return {
    type: types.SET_LINE_SERVICE_TYPE,
    serviceType
  }
}


export const getPurchaseInfoAction = (id) => {
  return {
    type: types.GET_GTM_PURCHASE_INFO_REQUEST,
    id
  }
}


export const commonResetPropsAction = () => {
  return {
    type: types.COMMON_PROPS_RESET,

  }
}



export const pushOperationLogsAction = (logs) => {
  return {
    type: Types.OPERATION_LOGS_PUSH,
    action: logs

  }
}



